import { render, staticRenderFns } from "./PedidoKanbanCard.vue?vue&type=template&id=28bffc8a&scoped=true"
import script from "./PedidoKanbanCard.vue?vue&type=script&lang=js"
export * from "./PedidoKanbanCard.vue?vue&type=script&lang=js"
import style0 from "./PedidoKanbanCard.vue?vue&type=style&index=0&id=28bffc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bffc8a",
  null
  
)

export default component.exports